import { styled } from "@mui/material";
import ReadonlyFeeScheduleCategoriesTable from "_shared/fee-schedules/categories/_views/readonly-fee-schedule-categories-table";
import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { FeeScheduleCategoryMaskedCurrency, Masked } from "work/masked-fields";
import WorkAgreement from "work/work-agreements/work-agreement";

const ListContainer = styled('div')(() => ({
  height: "100%",
  minHeight: "20rem",
}));
const CategorySelection = styled(ReadonlyFeeScheduleCategoriesTable)(() => ({
  height: "100%",
}));

type FeeScheduleTabProps = {
  workAgreement: WorkAgreement;
};

export default function FeeScheduleTab(props: Readonly<FeeScheduleTabProps>) {
  const { workAgreement } = props;

  const selectedCategories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[] = Masked.isPresentNotMasked(workAgreement.feeSchedule) ? workAgreement.feeSchedule : [];


  if (Masked.isMasked(workAgreement.feeSchedule)) {
    return "You do not have permission to view the fee schedule.";
  }

  return (
    <ListContainer>
      <CategorySelection categories={selectedCategories} />
    </ListContainer>
  );
}
